<template>
  <Wrapper>
    <WrapperSubpages>
      <Grid>
        <Header>
          <SubPageNavigator
            v-bind="{
              home: true,
              isHeader: true,
            }"
          />
        </Header>
        <Nav />
      </Grid>
      <section>
        <Grid>
          <div class="grid-column forSubPages">
            <div class="title txt">
              <h2>Act like a designer</h2>
              <p>
                Transformational design
                <br />Strategic design
                <br />Conceptional design
                <br />Facilitation
                <br />
              </p>
            </div>
            <div class="contentForSubPages txt">
              <mq-layout mq="m">
                <img src="/static/img/act-like-a-designer-01-m-633.svg" />
              </mq-layout>
              <mq-layout mq="s">
                <img src="/static/img/act-like-a-designer-01-s-598.svg" />
              </mq-layout>
              <mq-layout :mq="['xs', '<xs']">
                <img src="/static/img/act-like-a-designer-01-xs-275.svg" />
              </mq-layout>
              <p>
                The key to breakthrough innovation cannot be in the past but
                only in the present. Past experiences and data alone will not
                come up with bright solutions for the future. Your business
                advantage is about being brave and getting out of your comfort
                zone. Act like a designer, be passionate!
                <br />
                <Highlight>
                  <HighlightHook v-bind="{ label: 'Innovation' }">Consider</HighlightHook>&nbsp;the past, but form what is ahead of you.
                </Highlight>Observe your audience, use your imagination, configure
                completely new business values.
              </p>
              <p>
                I work with teams and leaders. Together we dig for product and
                service opportunities, evaluate bold ideas with empathy and form
                the foundation to sustainable solutions.
              </p>
              <h3 class="specialSpacing">I use design to:</h3>
              <ol class="specialSpacing">
                <li>Find patterns in chaos</li>
                <li>Change work for good</li>
                <li>Empower brands digitally</li>
                <li>Define and bring strategy to life</li>
                <li>Bridge the knowledge gap between people</li>
                <li>To prove strategies with creative prototypes</li>
                <li>Defend or sell new ideas to employees, boards and investors</li>
                <li>Make the outsiders visible</li>
              </ol>
              <p>
                <Highlight>
                  <HighlightHook v-bind="{ label: 'Qualification' }">I</HighlightHook>&nbsp; spent the last six years increasing the design
                  maturity of a multi-billion corporate group through the
                  complexity of digital transformation
                </Highlight>
              </p>
            </div>
          </div>
        </Grid>
      </section>
      <Grid>
        <div class="subpageEnd">
          <SubPageNavigator
            v-bind="{
              home: true,
              next: {
                number: 2,
                label: 'Getting practical',
                path: '/getting-practical',
              },
            }"
          />
        </div>
      </Grid>
    </WrapperSubpages>
  </Wrapper>
</template>
<script>
import Wrapper from "../Wrapper.vue";
import Grid from "../Grid.vue";
import Header from "../Header.vue";
import Nav from "../Nav.vue";
import WrapperSubpages from "./WrapperSubpages.vue";
import SubPageNavigator from "./SubPageNavigator.vue";
import Highlight from "./Highlight.vue";
import HighlightHook from "./HighlightHook.vue";

export default {
  name: "ActLikeADesigner",
  components: {
    Wrapper,
    Grid,
    Header,
    WrapperSubpages,
    SubPageNavigator,
    Nav,
    Highlight,
    HighlightHook,
  },
  data: function () {
    return {
      highlights: ["Innovation", "Qualification"],
    };
  },
};
</script>
<style scoped>
h3.specialSpacing {
  margin-top: calc(var(--LINE-HEIGHT) * 1);
}
ol.specialSpacing {
  margin-bottom: calc(var(--LINE-HEIGHT) * 2);
}
</style>



// WEBPACK FOOTER //
// src/components/subpages/ActLikeADesigner.vue